module.exports = __webpack_public_path__ + "media/Process Success.a7461396.wav";